import React from 'react';
import { Printer } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-white py-12 border-t border-neutral-800" data-id="element-46">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-47">
        <div className="flex items-center gap-2 mb-6" data-id="element-48">
          <Printer className="w-8 h-8" strokeWidth={2.5} data-id="element-49" />
          <span className="font-display font-bold text-2xl tracking-wider uppercase" data-id="element-50">
            STRATA CUSTOM APPAREL
          </span>
        </div>

        <div className="flex flex-col md:flex-row gap-4 md:gap-8 mb-8 text-gray-400 font-medium" data-id="element-51">
          <a href="tel:+18582542524" className="hover:text-white transition-colors" data-id="element-52">
            1-858-254-2524
          </a>
          <a href="https://wa.me/18582542524" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-53">
            WhatsApp
          </a>
          <a href="mailto:quotes@stratacustomapparel.com" className="hover:text-white transition-colors" data-id="element-54">
            quotes@stratacustomapparel.com
          </a>
          <span data-id="element-55">Printed with pride in the USA</span>
        </div>

        <p className="text-neutral-600 text-sm" data-id="element-56">
          &copy; {new Date().getFullYear()} Strata Custom Apparel. All rights
          reserved.
        </p>
      </div>
    </footer>;
}